import "./PatientVoices.module.css";
import Navigation from "@/reusable_sections/Header";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
export default function PatientVoicesPage() {
  return <div>
      <Navigation />
      <Testimonials />
      <Footer />
    </div>;
}